import { render, staticRenderFns } from "./product-complete-look.vue?vue&type=template&id=f902ba4e&"
import script from "./product-complete-look.vue?vue&type=script&lang=js&"
export * from "./product-complete-look.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cinderellamaecuya/SP/peppermayo-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f902ba4e')) {
      api.createRecord('f902ba4e', component.options)
    } else {
      api.reload('f902ba4e', component.options)
    }
    module.hot.accept("./product-complete-look.vue?vue&type=template&id=f902ba4e&", function () {
      api.rerender('f902ba4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/product-complete-look.vue"
export default component.exports